import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { useEmailChartData } from '@hooks/useDashboard'
import { formatDate } from '@lib/utils'

export function EmailChart() {
  const { data, isLoading, error } = useEmailChartData(7)

  if (isLoading) {
    return (
      <div className="flex h-80 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex h-80 items-center justify-center">
        <p className="text-gray-500">Failed to load chart data</p>
      </div>
    )
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex h-80 items-center justify-center">
        <p className="text-gray-500">No data available</p>
      </div>
    )
  }

  const formattedData = data.map((point) => ({
    ...point,
    date: formatDate(point.date),
  }))

  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart data={formattedData}>
        <defs>
          <linearGradient id="colorSent" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorDelivered" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorOpened" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorReplied" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#f59e0b" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis
          dataKey="date"
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <YAxis stroke="#6b7280" style={{ fontSize: '12px' }} />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: '0.5rem',
          }}
        />
        <Legend />
        <Area
          type="monotone"
          dataKey="sent"
          stroke="#3b82f6"
          strokeWidth={2}
          fill="url(#colorSent)"
          name="Sent"
        />
        <Area
          type="monotone"
          dataKey="delivered"
          stroke="#10b981"
          strokeWidth={2}
          fill="url(#colorDelivered)"
          name="Delivered"
        />
        <Area
          type="monotone"
          dataKey="opened"
          stroke="#8b5cf6"
          strokeWidth={2}
          fill="url(#colorOpened)"
          name="Opened"
        />
        <Area
          type="monotone"
          dataKey="replied"
          stroke="#f59e0b"
          strokeWidth={2}
          fill="url(#colorReplied)"
          name="Replied"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
